import { dispatch, getState } from '../../..';
import PumpingStationPumpMakeHelper, { IPumpingStationPumpMake } from '../../../../@types/model/masterData/pumpingStation/pumpMake';
import GeneralFunctions from '../../../general/functions';
import MasterDataPumpingStationPumpMakeActions from './actions';

export default class MasterDataPumpingStationPumpMakeFunctions {
    private static listener : undefined | (() => void);


    public static readonly load = async () => {
        if (MasterDataPumpingStationPumpMakeFunctions.listener) return;
        
        dispatch(MasterDataPumpingStationPumpMakeActions.setLoading(true));
        dispatch(MasterDataPumpingStationPumpMakeActions.set([]));

        try {
            MasterDataPumpingStationPumpMakeFunctions.listener = PumpingStationPumpMakeHelper
                .collection()
                .onSnapshot((snapshot : firebase.firestore.QuerySnapshot<IPumpingStationPumpMake>) => {
                    const state = getState().masterData.pumpingStation.pumpMake;

                    const list = state.pumpMakes.slice();
                
                    const session = getState().auth.session;
                    if (!session) return;

                    // "added" | "removed" | "modified"
                    snapshot.docChanges().forEach((f) => {
                        const item = f.doc.data();
                        const index = list.findIndex(n => n.id === item.id);


                        switch (f.type) {
                            case 'added':
                                list.push(item);
                                break;
                            case 'modified':
                                list.splice(index, 1, item);
                                break;
                            case 'removed':
                                list.splice(index, 1);
                                break;
                        }
                    });

                    dispatch(MasterDataPumpingStationPumpMakeActions.set(list));
                    dispatch(MasterDataPumpingStationPumpMakeActions.setLoading(false));
                }, (ex) => {
                    GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
                    dispatch(MasterDataPumpingStationPumpMakeActions.setLoading(false));
                }, () => {
                    dispatch(MasterDataPumpingStationPumpMakeActions.setLoading(false));
                    MasterDataPumpingStationPumpMakeFunctions.listener = undefined;
                });

        } catch (ex) {
            GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
            dispatch(MasterDataPumpingStationPumpMakeActions.setLoading(false));
        }
    };
}